import { homApi } from '~/redux/apis/hom'
import { userStats } from '~/games/types/windSurfer.types'

export const windSurferApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    setWindSurferStats: builder.mutation<{ type: 'success' | 'error' }, userStats>({
      query: (data) => ({
        url: '/v1/games/wind-surfer/activity',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['windSurfer'],
    }),

    getWindSurferStats: builder.query<unknown, void>({
      query: () => ({
        url: '/v1/games/wind-surfer/score',
        method: 'GET',
      }),
      providesTags: ['windSurfer'],
    }),
  }),
})

export const { useSetWindSurferStatsMutation, useGetWindSurferStatsQuery } = windSurferApi
